import QRCode from 'qrcode';

export const generateQRCode = async (url) => {
  const QRCodePromise = QRCode.toDataURL(url);

  try {
    return await QRCodePromise;
  } catch (err) {
    console.error(err);
  }
};
